import { render, staticRenderFns } from "./RecipeIngredientsList.vue?vue&type=template&id=f8856a30&scoped=true"
import script from "./RecipeIngredientsList.vue?vue&type=script&lang=js"
export * from "./RecipeIngredientsList.vue?vue&type=script&lang=js"
import style0 from "./RecipeIngredientsList.vue?vue&type=style&index=0&id=f8856a30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8856a30",
  null
  
)

export default component.exports